<template>
    <div>
        <b-table-simple responsive>
            <b-thead head-variant="dark">
                <b-tr>
                    <b-th class="hidden-row"></b-th>
                    <b-th>{{ 'sums' | lang }}</b-th>
                    <b-th>{{ 'multipliers' | lang }}</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="({ symbol, multiplier, sharing }, symbolId, index) in game.items" :key="symbolId">
                    <b-td :variant="index % 2 ? 'success-light' : 'success'">{{ symbol }}</b-td>
                    <b-td :variant="index % 2 ? 'light' : ''">{{ game.odds[symbol].join(', ') }}</b-td>
                    <b-td :variant="index % 2 ? 'light' : ''">{{ multiplier }} <span v-if="sharing" class="text-danger">*</span></b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
        <div>
            <span class="text-danger">*</span>
            <span>{{ 'rules.if_more_winners' | lang }}</span>
            <div>
                <span class="text-danger">**</span>
                <span>{{ 'rules.dice_explain' | lang }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['game'],

    computed: {

        guessNumbers() {
            const values = Object.values(this.game.guesses_values)
                .map(item => item.guessed);
            
            return [ ...new Set(values) ].reverse();
        },
    },
}
</script>